import { useContext, useEffect, useState } from "react";
import TextWithCheckboxField from "../../../../components/textWithCheckboxField/textWithCheckboxField";
import KrFormContext, { KrFormContextLandslideType, KrLandslideFormTypes, landSlideAttributes, MonitoringRegisters, NavHeadingsKROEnum } from "../../../../contexts/krFormContext";
import { TextWithCheckBoxFieldProps } from "../../../../components/textWithCheckboxField/types/textWithCheckboxFieldProps";
import { createConfigValidation, createMonitoringValidation, validation } from "../../../../helpers/validation/validation";
import CheckboxField from "../../../../components/checkboxField/checkboxField";
import { styleFormField, styleFormFieldHalf, styleFormFieldOnThree, stylizationVerticalAlign } from "../../../../components/shared/stylization";
import ButtonField from "../../../../components/buttonField/buttonField";
import { ReactComponent as addCircleIcon } from '../../../../icons/add_circle.svg';
import { ConductingObservationTypes } from "../types/krFormView";
import { classNameBtn, iconPosition } from "../../../../components/shared/button/types/buttonProps";
import { ButtonFieldProps } from "../../../../components/buttonField/types/buttonFieldProps";
import Table from "../../../../components/shared/table/table";
import ConfirmModal from "../../../../components/modalWindow/confirmModal";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { TableProps } from "../../../../components/shared/table/types/tableProps";
import { HeadersTable } from "../../../../helpers/featureTableConstruct";
import TableActions from "../../../../components/shared/table/tableActions/tableActions";
import MonitoringEdit from "./shared/monitoringEdit/monitoringEdit";
import { GetOptions, prepareDataSingleForSelect } from "../../../../helpers/prepareForSelect";
import { checkIfMarkedForCommentFilter, fireAddCommentBtnOnClickForRow, getAddCommentBtnDetails, getFieldRef, getFieldRefForRow, getItemRef, getKRDictFieldNameForRow, renderSectionCommentBtn } from "../../../../helpers/form";
import { KROFieldDict } from "../../shared/commentsSidebar/fieldDict";
import { FormSectionProps } from "./shared/types/formSectionProps";
import TextAreaField from "../../../../components/textAreaField/textAreaField";
import { TextAreaFieldProps } from "../../../../components/textAreaField/types/textAreaFieldProps";
import SelectInput from "../../../../components/shared/selectInput/selectInput";
import { Option } from "../../../../components/shared/selectInput/types/selectInputProps";
import { PatternType } from "../../../../contexts/types/card";

type tableRecord = {
    id?: string,
    type?: string,
    date?: string,
    contractor?: string,
    description?: string,
    localUUID?: string
}

type monitoringRecord = {
    rok?: number,
    miesiac?: number,
    dzien?: number,
    opis?: string,

}

const ConductingObservation = (props: FormSectionProps & {
    is2007: boolean
}) => {

    const checkIfHasValue = (value: string | undefined | null, name?: string) => {
        if (value !== undefined && value !== "" && value != null && value.toLowerCase() !== "brak wskazań") {
            return false;
        }
        return true;
    }

    const { krForm, setkrForm } = useContext(KrFormContext) as KrFormContextLandslideType;
    const [monitoringWizji, setMonitoringWizji] = useState(checkIfHasValue(krForm.landslideAttributes?.monitorinG_WSKAZ_WIZJI, "monitorinG_WSKAZ_WIZJI"));
    const [pristineMonitoringWizji, setPristineMonitoringWizji] = useState(true);
    const [monitoringMon, setMonitoringMon] = useState(checkIfHasValue(krForm.landslideAttributes?.monitorinG_WSKAZ_MON, "monitorinG_WSKAZ_MON"));
    const [pristineMonitoringMon, setPristineMonitoringMon] = useState(true);
    const [checkToggleCheckbox, setCheckToggleCheckbox] = useState(props.version === PatternType.P2007 ? krForm.landslideAttributes?.czY_MONITORING !== 1 : 
        krForm.landslideAttributes?.czY_MONITORING_POWIERZCHNIOWY !== 1 && krForm.landslideAttributes?.czY_MONITORING_WGLEBNY !== 1);
    const [showForm, setShowForm] = useState(false);
    const [activeBtn, setActiveBtn] = useState<ConductingObservationTypes | null>(null);

    const [monitoringRow, setMonitoringRow] = useState<any>(null);
    const [confirmation, setConfirmation] = useState<boolean>(false);
    const [reload, setReload] = useState<boolean>(false);
    const [visibilityRows, setVisibilityRows] = useState<string[]>([]);
    //const [fileRow, setFileRow] = useState<MonitoringAttachments>();
    //const [confirmationMonitoring, setConfirmationMonitoring] = useState<boolean>(false);
    const [tableError, setTableError] = useState<boolean>(false);
    const [tableErrorMsg, setTableErrorMsg] = useState<string>('');
    const [isMonitoringError, setIsMonitoringError] = useState<boolean>(false);
    const [isMonitoringErrorMsg, setIsMonitoringErrorMsg] = useState<string>('');
    const [editRow, setEditRow] = useState<boolean>(false);
    const [editedRow, setEditedRow] = useState<MonitoringRegisters>({});
    const [focusTable, setFocusTable] = useState<boolean>(false);

    const refocus = () => {
        setFocusTable(true);
    }

    const MonitoringStatusOptions: Option[] = [
        { name: "brak", value: 0 },
        { name: "w trakcie", value: 1 },
        { name: "wstrzymany", value: 2 },
        { name: "zakończony", value: 3 },
    ]

    // Validation
    useEffect(() => {
        if (krForm.config?.check && !krForm.config.isValid) {
            setErrors(krForm.config?.ValidationError);
        }
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [krForm.config?.check])

    const refreshValidation = (form: KrLandslideFormTypes) => {
        let errorsValidation = createMonitoringValidation(form, props.objectType, props.version);
        var errors: Record<string, string> = {};
    
        errors["landslideMonitoringRegisters"] = validation(errorsValidation["landslideMonitoringRegisters"], form.landslideMonitoringRegisters);
        if (props.version === PatternType.P2007) {
            errors["czY_MONITORING"] = validation(errorsValidation["czY_MONITORING"], form.landslideAttributes?.czY_MONITORING);
        } else {
            errors["czY_MONITORING_POWIERZCHNIOWY"] = validation(errorsValidation["czY_MONITORING_POWIERZCHNIOWY"], form.landslideAttributes?.czY_MONITORING_POWIERZCHNIOWY);
            errors["czY_MONITORING_WGLEBNY"] = validation(errorsValidation["czY_MONITORING_WGLEBNY"], form.landslideAttributes?.czY_MONITORING_WGLEBNY);
        }

        setErrors(errors);
    }

    const setErrors = (errors?: Record<string, string> | undefined) => {
        if (errors) {
            const tErrorMsg = errors["landslideMonitoringRegisters"];
            if (tErrorMsg) {
                setTableError(true);
                setTableErrorMsg(tErrorMsg);
            } else {
                setTableError(false);
                setTableErrorMsg('');
            }
            let mErrorMsg = null;
            if (props.version === PatternType.P2007) {
                mErrorMsg = errors["czY_MONITORING"];
            } else {
                mErrorMsg = getError(errors, "czY_MONITORING_POWIERZCHNIOWY", tErrorMsg ? "" : "dla monitoringu powierzchniowego");
                if (!mErrorMsg) {
                    mErrorMsg = getError(errors, "czY_MONITORING_WGLEBNY", tErrorMsg ? "" : "dla monitoringu wgłębnego");
                }
            }
            if (mErrorMsg) {
                setIsMonitoringError(true);
                setIsMonitoringErrorMsg(mErrorMsg);
            } else {
                setIsMonitoringError(false);
                setIsMonitoringErrorMsg('');
            }
        } else {
            setTableError(false);
            setTableErrorMsg('');
            setIsMonitoringError(false);
            setIsMonitoringErrorMsg('');
        }
    }

    const getError = (errors: Record<string, string>, field: string, extraMsg: string) => {
        let err = errors[field];
        if (err) {
            return `${err} ${extraMsg}`;
        }
        return null;
    }

    var monitoringTypeDict = GetOptions("RODZAJ_MONITORINGU_SID", krForm.dictionaries);

    const createTableList = () => {
        var records: tableRecord[] = [];
        if (krForm.landslideMonitoringRegisters) {
            for (var i = 0; i < krForm.landslideMonitoringRegisters?.length; i++) {
                var record: tableRecord = {};
                // eslint-disable-next-line no-loop-func
                var opt = monitoringTypeDict?.find((option) => {
                    if (krForm.landslideMonitoringRegisters) {
                        return option.value === krForm.landslideMonitoringRegisters[i].rodzaJ_MONITORINGU_SID
                    }
                    return undefined;
                })
                if (opt) {
                    record.type = opt.name;
                }


                // record.date = krForm.landslideMonitoringRegisters[i].datA_OD_VIEW;
                // if (krForm.landslideMonitoringRegisters[i].datA_DO_VIEW) {
                //     record.date += " - " + krForm.landslideMonitoringRegisters[i].datA_DO_VIEW;
                // }

                
                record.date = new Date(krForm.landslideMonitoringRegisters[i].datA_OD).toLocaleDateString("fr-CA");
                if (krForm.landslideMonitoringRegisters[i].datA_DO) {
                    record.date += " - " + new Date(krForm.landslideMonitoringRegisters[i].datA_DO).toLocaleDateString("fr-CA");
                }
                record.contractor = krForm.landslideMonitoringRegisters[i].wykonawca;
                record.description = krForm.landslideMonitoringRegisters[i].opis;
                record.id = krForm.landslideMonitoringRegisters[i].globalid;
                record.localUUID = krForm.landslideMonitoringRegisters[i].localUUID;
                records.push(record);
            }
        }
        return records;
    }

    useEffect(() => {
        setReload(!reload);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [krForm.landslideMonitoringRegisters]);

    var defaultMonitoring: monitoringRecord = {};

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [monitoringRecord, setMonitoringRecord] = useState<monitoringRecord>(defaultMonitoring);

    const focusChange = (name: string, set: Function, state: boolean) => {
        if (state) {
            var form: any = Object.assign({}, krForm);
            if (form.landslideAttributes) {
                form.landslideAttributes[name as keyof landSlideAttributes] = "";
                setkrForm(form);
            }
            set(!state);
        }
    }

    const checkboxChange = (name: string, set: Function, state: boolean, setPristine: Function) => {
        var form = Object.assign({}, krForm);
        if (!state && form !== null && form.landslideAttributes) {
            form.landslideAttributes[name as keyof landSlideAttributes] = "Brak wskazań";
            if (name === "monitorinG_WSKAZ_WIZJI") form.landslideAttributes.czY_WSKAZANIE_WIZJA = 0;
            if (name === "monitorinG_WSKAZ_MON") form.landslideAttributes.czY_WSKAZANIE_MONITORING = 0;           
            setkrForm(form);
            set(true);
        }
        else {
            if (form.landslideAttributes) {
                form.landslideAttributes[name as keyof landSlideAttributes] = "";
                setkrForm(form);
                set(false);
            }
        }
        setPristine(false);
    }

    const createProps = (name: string, setELement: Function, element: boolean, labelName: string, pristine: boolean, setPristine: Function,
        KRFieldDict: KROFieldDict, fieldFormName: string) => {
        var valueCopy = krForm.landslideAttributes ? krForm.landslideAttributes[name as keyof landSlideAttributes] : "";
        var textWithCheckboxProps: TextWithCheckBoxFieldProps = {
            textAreaProps: {
                labelName: labelName,
                textAreaPlaceholder: 'Dodaj opis',
                value: valueCopy,
                textareaSharedProps: {
                    className: 'body-txt-large',
                    style: {
                        width: '100%',
                        minHeight: '70px'
                    }
                },
                onFocusText: () => { focusChange(name, setELement, element) },
                //onBlurText: (event: any) => { blurChange(event, "zabezpieczeniE_OPIS", setSafeguard, safeguard) },
                setValue: (value: any) => {
                    var form: any = Object.assign({}, krForm);
                    if (form && form.landslideAttributes) {
                        form.landslideAttributes[name] = value;
                        if (value && value.toLowerCase() !== "brak wskazań") {
                            if (name === "monitorinG_WSKAZ_WIZJI") {
                                form.landslideAttributes.czY_WSKAZANIE_WIZJA = 1;
                                if (monitoringWizji) setMonitoringWizji(false);
                            }
                            if (name === "monitorinG_WSKAZ_MON") {
                                form.landslideAttributes.czY_WSKAZANIE_MONITORING = 1;
                                if (monitoringMon) setMonitoringMon(false);
                            }
                        }
                        else {
                            if (name === "monitorinG_WSKAZ_WIZJI") form.landslideAttributes.czY_WSKAZANIE_WIZJA = 0;
                            if (name === "monitorinG_WSKAZ_MON") form.landslideAttributes.czY_WSKAZANIE_MONITORING = 0;
                            if (value.toLowerCase() === "brak wskazań") name === "monitorinG_WSKAZ_WIZJI" ? setMonitoringWizji(true) : setMonitoringMon(true);
                        }
                        setkrForm(form);
                    }
                },
                configValidation: createConfigValidation(name),
                pristine: pristine,
                disabled: !props.editMode,
                addCommentBtn: getAddCommentBtnDetails(props.editMode!, KRFieldDict, fieldFormName, props.setNewCommentFieldDetails!),
                textareaRef: (node: any) => {getFieldRef(node, KRFieldDict, props.getMapForComment!)},
                setCommentsFilter: () => { if(props.setCommentsFilter) props.setCommentsFilter(KRFieldDict); },
                isMarkedForCommentFilter: props.markedFieldForCommentFiltering === KRFieldDict,
                dynamicResize: true
            },
            checkBoxProps: {
                onChange: () => { checkboxChange(name, setELement, element, setPristine) },
                labelName: 'Brak wskazań',
                inputChecked: element,
                disabled: !props.editMode
            }
        }
        return textWithCheckboxProps;
    }

    const onChangeCheckboxSingle = (e: any) => {
        var form = Object.assign({}, krForm);
        let checkValue = checkToggleCheckbox ? 1 : 0;
        if (form.landslideAttributes) {
            if (props.version === PatternType.P2007) {
                form.landslideAttributes.czY_MONITORING = checkValue;
                //form.landslideAttributes.monitorinG_OPIS = "";
            } else {
                form.landslideAttributes.czY_MONITORING_POWIERZCHNIOWY = checkValue;
                //form.landslideAttributes.monitorinG_POW = "";
                form.landslideAttributes.czY_MONITORING_WGLEBNY = checkValue;
                //form.landslideAttributes.monitorinG_WGL = "";
            }
        }
        if (!checkValue) {
            form.landslideMonitoringRegisters = [];
            form.landslideMonitoringAttachments = [];
        }
        setCheckToggleCheckbox(!checkToggleCheckbox);
        setShowForm(checkToggleCheckbox);
        setActiveBtn(null);
        setkrForm(form);

        refreshValidation(form);
    }

    const clearFields = () => {

    }

    const switchButton = (actionType: ConductingObservationTypes) => {
        setActiveBtn(actionType);
        var Monitoring = defaultMonitoring;
        if (Monitoring) Monitoring.rok = actionType;
        clearFields();
        setShowForm(true);
        setMonitoringRecord(Monitoring);
    }

    const addMonitoring = (e: any) => {
        var form = Object.assign({}, krForm);
        if (form && form.landslideAttributes) {
            setkrForm(form);
            refreshValidation(form);
        }
    }

    const updateCheckboxAfterTableChange = (attributes?: landSlideAttributes | undefined) => {
        if (attributes) {
            if (props.version === PatternType.P2007) {
                setCheckToggleCheckbox(attributes.czY_MONITORING !== 1);
            } else {
                setCheckToggleCheckbox(attributes.czY_MONITORING_POWIERZCHNIOWY !== 1 && attributes.czY_MONITORING_WGLEBNY !== 1);
            }
        }
    }

    const getBtnProps = (actionType: ConductingObservationTypes, title: any, icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>,
        buttonSize?: classNameBtn, AddMonitoring?: boolean): ButtonFieldProps => {
        let className = classNameBtn.Big + " body-txt-large monitoringBtns";
        if (buttonSize) className = buttonSize;
        if (actionType === activeBtn && !AddMonitoring) {
            className += " bigBtnActive";
        }
        return {
            BtnProps: {
                onClick: (e: any) => { AddMonitoring ? addMonitoring(e) : switchButton(actionType) },
                style: {
                    width: '100%',
                    maxHeight: '80px'
                },
                className: className
            },
            placeHolder: title,
            placeHolderStyle: stylizationVerticalAlign,
            additionalIcon: icon,
            iconPosition: iconPosition.Start,
            wrapperProps: {
                style: styleFormFieldOnThree
            }
        };
    }

    const handleEditClick = (row: any) => {
        if (visibilityRows.length === 0) {
            setVisibilityRows([...visibilityRows, row.id]);
            setEditRow(true);
            setShowForm(true);
            var editedRow = Object.assign({}, krForm.landslideMonitoringRegisters?.find(item => row.id === item.globalid));
            if (editedRow?.rodzaJ_MONITORINGU_SID) setActiveBtn(editedRow?.rodzaJ_MONITORINGU_SID);
            if (editedRow) setEditedRow(editedRow);
        }
    }

    const handleCloseClick = () => {
        setVisibilityRows([]);
        setEditRow(false);
        setActiveBtn(null)
    }

    useEffect(() => {
        if (activeBtn === null && visibilityRows.length > 0) setVisibilityRows([]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeBtn])

    const cellAction = (properties: CellContext<any, unknown>) => {
        return (<TableActions
            row={properties.row}
            objectType={"rasters"}
            deleteClickHandler={handleDeleteClick}
            editClickHandler={handleEditClick}
            closeClickHandler={handleCloseClick}
            visibilityRows={visibilityRows}
            fieldName="id"
            addCommentBtnVisible={!props.editMode}
            addCommentBtnClickHandler={handleAddCommentClick}
            addCommentBtnRef={getAddCommentBtnRef}
            checkIfMarkedForCommentFilter={checkIfRowMarkedForCommentFilter}
        />)
    }

    let headers = {
        type: "Rodzaj monitoringu",
        date: "Data przeprowadzania",
        contractor: "Wykonawca",
        description: "Opis"
    };

    let headers2007 = {
        date: "Data przeprowadzania",
        contractor: "Wykonawca",
        description: "Opis"
    };

    const checkIfRowMarkedForCommentFilter = (row: any) => {
        if (props.markedFieldForCommentFiltering) {
            return checkIfMarkedForCommentFilter(KROFieldDict.obserw_dotychczasProwadzonyMonitoring, row.id, props.markedFieldForCommentFiltering)
        }
    }

    const handleAddCommentClick = (row: any) => {
        fireAddCommentBtnOnClickForRow(KROFieldDict.obserw_dotychczasProwadzonyMonitoring, row.id, 
            "Wiersz sekcji: Monitoring", 
            props.setNewCommentFieldDetails!);
    }

    const getAddCommentBtnRef = (node: any, row: any) => {
        getFieldRefForRow(node, KROFieldDict.obserw_dotychczasProwadzonyMonitoring, row.id, props.getMapForComment!);
    }

    const handleDeleteClick = (row: any) => {
        setMonitoringRow(row);
        setConfirmation(true);
    }

    const deleteMonitoring = (row: any) => {
        var form = structuredClone(krForm);
        form.landslideMonitoringRegisters = form.landslideMonitoringRegisters?.filter(item => {
            return item.globalid !== row.id;
        });
        form.landslideMonitoringAttachments = form.landslideMonitoringAttachments?.filter(item => {
            return item.monitorinG_REJESTR_GID !== row.id;
        });
        changeMonitoring(form);
    }

    const confirm = () => {
        setConfirmation(false);
        deleteMonitoring(monitoringRow);
    }

    const getQuestion = () => {
        return `Czy na pewno chcesz usunąć monitoring?`;
    }

    const cancel = () => {
        setConfirmation(false);
    }

    var tableProps: TableProps = {
        columnAliases: !props.is2007 ? headers : headers2007,
        columnHelper: createColumnHelper<HeadersTable>(),
        columnNames: Object.keys(!props.is2007 ? headers : headers2007),
        cellActions: cellAction,
        data: krForm.landslideMonitoringRegisters ? createTableList() : [],
        loading: false,
        className: "table",
        tableError: tableError,
        tableErrorMsg: tableErrorMsg,
        setCommentsFilter: (row: any) => { if (props.setCommentsFilter) props.setCommentsFilter(getKRDictFieldNameForRow(KROFieldDict.obserw_dotychczasProwadzonyMonitoring, row.id)); },
        checkIfMarkedForCommentFilter: (row: any) => { checkIfRowMarkedForCommentFilter(row) },
        narrowTableForCommentBtns: !props.editMode,
        refocus: focusTable,
        setRefocusTable: setFocusTable
    }

    const getSectionHeading = () => {
        if (props.is2007) return "12. Prowadzenie instrumentalnych prac monitoringowych";
        else return "12. Prowadzenie obserwacji"
    }

    var getTextAreaProps = (label: string, nameForValue: string, KRFieldDict: KROFieldDict, fieldFormName: string): TextAreaFieldProps => {
        var valueCopy = krForm.landslideAttributes ? krForm.landslideAttributes[nameForValue as keyof landSlideAttributes] : "";
        return {
            labelName: label,
            textAreaPlaceholder: 'Dodaj opis',
            textareaSharedProps: {
                className: 'body-txt-large',
                style: {
                    width: '100%',
                    minHeight: '70px'
                }
            },
            pristine: true,
            setValue: (value: any) => {
                var form: any = Object.assign({}, krForm);
                if (form && form.landslideAttributes) {
                    form.landslideAttributes[nameForValue] = value;
                    /*
                    let isMonitoring = value !== null && value !== undefined && value !== "" && value?.toLowerCase() !== "nie" ? 1 : 0;
                    if (nameForValue === "monitorinG_OPIS") {
                        form.landslideAttributes.czY_MONITORING = isMonitoring;
                    } else if (nameForValue === "monitorinG_POW") {
                        form.landslideAttributes.czY_MONITORING_POWIERZCHNIOWY = isMonitoring;
                    } else if (nameForValue === "monitorinG_WGL") {
                        form.landslideAttributes.czY_MONITORING_WGLEBNY = isMonitoring;
                    }
                    */
                    setkrForm(form);
                }
            },
            dynamicResize: true,
            value: valueCopy,
            keepPristine: true,
            disabled: !props.editMode,
            addCommentBtn: getAddCommentBtnDetails(props.editMode!, KRFieldDict, fieldFormName, props.setNewCommentFieldDetails!),
            textareaRef: (node: any) => {getFieldRef(node, KRFieldDict, props.getMapForComment!)},
            setCommentsFilter: () => { if(props.setCommentsFilter) props.setCommentsFilter(KRFieldDict); },
            isMarkedForCommentFilter: props.markedFieldForCommentFiltering === KRFieldDict,
        }
    }

    const changeMonitoring = (_form: KrLandslideFormTypes) => {
        let f = updateMonitoringDescriptions(_form);
        setkrForm(f);
        refreshValidation(f);
        updateCheckboxAfterTableChange(f.landslideAttributes);
    }

    const updateMonitoringDescriptions = (currentForm: KrLandslideFormTypes) => {
        if (currentForm.landslideAttributes) {
            if (props.version === PatternType.P2020) {
                var currentPow = currentForm.landslideMonitoringRegisters?.filter(item => item.rodzaJ_MONITORINGU_SID === 1 || item.rodzaJ_MONITORINGU_SID === 3);
                var currentWgl = currentForm.landslideMonitoringRegisters?.filter(item => item.rodzaJ_MONITORINGU_SID === 2 || item.rodzaJ_MONITORINGU_SID === 3);
    
                if (currentPow?.length === 0) {
                    currentForm.landslideAttributes.monitorinG_POW = "";
                    currentForm.landslideAttributes.czY_MONITORING_POWIERZCHNIOWY = 0;
                }
                else currentForm.landslideAttributes.czY_MONITORING_POWIERZCHNIOWY = 1;
                if (currentWgl?.length === 0) {
                    currentForm.landslideAttributes.monitorinG_WGL = "";
                    currentForm.landslideAttributes.czY_MONITORING_WGLEBNY = 0;
                }
                else currentForm.landslideAttributes.czY_MONITORING_WGLEBNY = 1;
            } else if (props.version === PatternType.P2007) {
                if (currentForm.landslideMonitoringRegisters?.length === 0) {
                    currentForm.landslideAttributes.monitorinG_OPIS = "";
                    currentForm.landslideAttributes.czY_MONITORING = 0;
                } else {
                    currentForm.landslideAttributes.czY_MONITORING = 1;
                }
            }
    
            currentForm.landslideAttributes.czY_ZALACZNIK_MONITORINGU = currentForm.landslideMonitoringAttachments && currentForm.landslideMonitoringAttachments?.length > 0 ? 1 : 0;
        }
        
        return currentForm;
    }

    const statusOnChange = (opt: Option[]) => {
        var form = Object.assign({}, krForm);        
        if (form.landslideAttributes) form.landslideAttributes.monitorinG_STATUS = opt.length > 0 ? opt[0].value as number : undefined;
        setkrForm(form);
    }
    
    return (
        <>
            <div ref={(node: any) => {getFieldRef(node, KROFieldDict.obserw_sekcja, props.getMapForComment!)}} style={{ width: '100%' }}></div>
            <h2 ref={(node) => getItemRef(node, NavHeadingsKROEnum.ConductingObservation, props.getMapForNavScroll!)}
                onClick={() => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.obserw_sekcja); }}
            >{getSectionHeading()}</h2>
            {props.is2007 && !props.editMode && renderSectionCommentBtn(props.markedFieldForCommentFiltering === KROFieldDict.obserw_sekcja, false, getSectionHeading(), props.setNewCommentFieldDetails!, KROFieldDict.obserw_sekcja)}
            {!props.is2007 && 
            <>
                <TextWithCheckboxField {...createProps("monitorinG_WSKAZ_WIZJI", setMonitoringWizji,
                    monitoringWizji, "Wskazania do prowadzenia wizji w terenie", pristineMonitoringWizji, setPristineMonitoringWizji, 
                    KROFieldDict.obserw_wskazaniaDoProwadzeniaWizjiWTerenie, "Wskazania do prowadzenia wizji w terenie")} />
                <TextWithCheckboxField {...createProps("monitorinG_WSKAZ_MON", setMonitoringMon, monitoringMon,
                    "Wskazania do wprowadzenia monitoringu", pristineMonitoringMon, setPristineMonitoringMon, 
                    KROFieldDict.obserw_wskazaniaDoWprowadzeniaMonitoringu, "Wskazania do wprowadzenia monitoringu")} />
                <h3 onClick={() => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.obserw_monitoring_podsekcja); }}
                    ref={(node: any) => {getFieldRef(node, KROFieldDict.obserw_monitoring_podsekcja, props.getMapForComment!)}} style={{ width: '100%' }}
                >Monitoring</h3>
                {!props.editMode && renderSectionCommentBtn(props.markedFieldForCommentFiltering === KROFieldDict.obserw_monitoring_podsekcja, false, "Monitoring", props.setNewCommentFieldDetails!, KROFieldDict.obserw_monitoring_podsekcja)}
            </>}           
            <CheckboxField style={styleFormField} labelName="nie prowadzono" value={"monitoring"} inputChecked={checkToggleCheckbox} checkmarkSmall={false} onChange={onChangeCheckboxSingle} 
                disabled={!props.editMode} errorTip={isMonitoringError ? isMonitoringErrorMsg : null}/>
            {props.editMode &&
                <>
                    {!props.is2007 ? <><ButtonField {...getBtnProps(ConductingObservationTypes.SurfaceMonitoring, "Monitoring powierzchniowy", addCircleIcon)}></ButtonField>
                    <ButtonField {...getBtnProps(ConductingObservationTypes.InDepthMonitoring, "Monitoring wgłębny", addCircleIcon)}></ButtonField>
                    <ButtonField {...getBtnProps(ConductingObservationTypes.SurfaceAndInDepthMonitoring, <>Monitoring powierzchniowy <br></br>i wgłębny</>, addCircleIcon)}></ButtonField></> :
                    <><ButtonField {...getBtnProps(ConductingObservationTypes.SurfaceMonitoring, "Dodaj monitoring", addCircleIcon)}></ButtonField><div style={styleFormFieldHalf}></div></>}
                </>
            }
            {showForm && activeBtn != null && <MonitoringEdit
                monitoringType={activeBtn}
                isLandslide={true}
                refreshValidation={refreshValidation}
                editRow={editRow}
                setEditRow={setEditRow}
                editedRow={editedRow}
                setActiveBtn={setActiveBtn}
                customUpdate={changeMonitoring}
            />}
            {(showForm || !checkToggleCheckbox || (krForm.landslideMonitoringRegisters !== undefined ? krForm.landslideMonitoringRegisters.length > 0 : false)) && <>
                <Table {...tableProps} /> <br />
                {confirmation &&
                    <ConfirmModal width={"660px"} height={"auto"}
                        confirmTitle={"Tak, usuń monitoring"}
                        onConfirm={confirm}
                        cancelTitle={"Anuluj"}
                        onCancel={cancel}
                        question={getQuestion()}
                        refocus={refocus}
                    />}
            </>}
            {props.version === PatternType.P2007 ?
                <>
                    <br />
                    <TextAreaField {...getTextAreaProps(
                        "Prowadzenie instrumentalnych prac monitoringowych",
                        "monitorinG_OPIS",
                        KROFieldDict.obserw_prowadzenieInstrumentalnychPracMonitoringowych,
                        "Prowadzenie instrumentalnych prac monitoringowych")} />
                </> :
                <>
                    <br />
                    <TextAreaField {...getTextAreaProps(
                        "Dotychczas prowadzony monitoring powierzchniowy",
                        "monitorinG_POW",
                        KROFieldDict.obserw_dotychczasProwadzonyMonitoringPowierzchniowy,
                        "Dotychczas prowadzony monitoring powierzchniowy")} />

                    <br />
                    <TextAreaField {...getTextAreaProps(
                        "Dotychczas prowadzony monitoring wgłębny",
                        "monitorinG_WGL",
                        KROFieldDict.obserw_dotychczasProwadzonyMonitoringWglebny,
                        "Dotychczas prowadzony monitoring wgłębny")} />
                </>
            }
            <div style={{width: "100%"}}>
                <SelectInput 
                        placeHolder="Wybierz status monitoringu"  
                        label="Status monitoringu"
                        hasInputTags={true} 
                        options={MonitoringStatusOptions} 
                        onlySingleTag={true} 
                        style={{...styleFormFieldHalf, marginTop: "20px"}}
                        selectedOptions={prepareDataSingleForSelect(MonitoringStatusOptions, [krForm.landslideAttributes?.monitorinG_STATUS])}
                        onChange={statusOnChange} 
                        disabled={!props.editMode}
                        addCommentBtn={getAddCommentBtnDetails(props.editMode!, KROFieldDict.obserw_statusMonitoringu, "Status monitoringu", props.setNewCommentFieldDetails!)}
                        selectRef={(node: any) => {getFieldRef(node, KROFieldDict.obserw_statusMonitoringu, props.getMapForComment!)}} 
                        setCommentsFilter={() => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.obserw_statusMonitoringu); }}
                        isMarkedForCommentFilter={props.markedFieldForCommentFiltering === KROFieldDict.obserw_statusMonitoringu}/>
            </div>
        </>
    )
}

export default ConductingObservation;